<template>
  <div class="tickets-list-wrapper">
    <home-page @read="onRead" v-if="read === 1" />
    <div v-else>
      <display-navigation v-if="spotId === '0'" path="spots_list" title="景区详情" />
      <display-swipe :items="swipes" />
      <display-tickets
        :items="categories"
        :defaultActive="defaultActive"
        @change="onChangeTicketDetail"
      />
      <display-description :value="description" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { Dialog } from 'vant';
import { getTickets, getHomePage } from '@/api/api-ticket';
import DisplayNavigation from '@/components/DisplayNavigation.vue';
import DisplaySwipe from '@/components/DisplaySwipe.vue';
import DisplayTickets from '@/components/DisplayTickets.vue';
import DisplayDescription from '@/components/DisplayDescription.vue';
import HomePage from './HomePage.vue';

export default {
  components: {
    DisplayNavigation,
    DisplaySwipe,
    DisplayTickets,
    DisplayDescription,
    HomePage,
  },
  data() {
    return {
      swipes: [],
      categories: [],
      description: '',
      spotDetail: {},
      defaultActive: 0,
    };
  },
  computed: {
    ...mapGetters(['spotId', 'homePage']),
    id() {
      return this.$route.params.id || this.spotId;
    },
    read() {
      return this.homePage.read;
    },
  },
  created() {
    this.handleGet();
  },
  methods: {
    ...mapMutations(['setHomePage']),
    async handleGet() {
      const data = await getTickets(this.id);
      const homePage = await getHomePage(this.id);
      this.categories = data;
      this.description = data[0].content;
      this.spotDetail = data[0].ticket;
      if (typeof data[0].banner === 'string') {
        const swipes = [];
        swipes.push(data[0].banner);
        this.swipes = swipes;
      } else {
        this.swipes = data[0].banner;
      }
      await this.onHomePage(data, homePage);
      const parkId = window.sessionStorage.getItem('parkId');
      this.defaultActive = parkId ? data.findIndex(item => Number(item.id) === Number(parkId)) : 0;
    },
    onChangeTicketDetail(value) {
      const { banner, content, ticket } = value;
      this.description = content;
      this.spotDetail = ticket;
      if (typeof banner === 'string') {
        const swipes = [];
        swipes.push(banner);
        this.swipes = swipes;
      } else {
        this.swipes = banner;
      }
      this.onCloseNotice(value);
    },
    onCloseNotice(value) {
      if (value.close_notice_status && !!value.close_notice)
        Dialog.alert({
          width: '260px',
          message: value.close_notice,
          closeOnClickOverlay: true,
        });
    },
    onHomePage(data, homePage) {
      if (homePage.content.slice(1) && (this.read === -1 || this.read === 1)) {
        const content = homePage.content.replace(/<img/gi, '<img style="width: 100%;height:auto"');
        this.setHomePage({ ...homePage, content, read: 1 });
      } else {
        this.setHomePage({ ...homePage, read: 0 });
        this.onCloseNotice(data.length ? data[0] : {});
      }
    },
    onRead() {
      if (!Number(this.spotId)) this.setHomePage({ ...this.homePage, read: -1 });
      else this.setHomePage({ ...this.homePage, read: 0 });
      this.onCloseNotice(this.categories.length ? this.categories[0] : {});
    },
  },
};
</script>
<style lang="less" scoped>
.tickets-list-wrapper {
  margin-bottom: 100px;
}
</style>
